import axios from "axios";

export const fetchAuditTrail = async () => {
  const response = await axios.get("/Audit/list");
  return response;
};
